export default __webpack_public_path__ + "static/media/pencil-alt.2c077888.svg";